import { Entity } from './types'

export const createDinamicColumnKey = (date: string) => {
  return `${Entity.Date}_${date}`
}

export const extractDateFromColumnKey = (columnKey: string) => {
  return columnKey.replace(`${Entity.Date}_`, '')
}

export const columnKeysLeft = [Entity.Count, Entity.Category]
export const columnKeysLeftHeaders = [columnKeysLeft]

export const columnKeysRight = [Entity.Total]
export const columnKeysRightHeaders = [columnKeysRight]

export const createColumnKeysMain = (dates: Array<string>) => {
  return dates.map((date) => createDinamicColumnKey(date))
}

export const createColumnKeysMainHeaders = (dates: Array<string>) => {
  return [createColumnKeysMain(dates)]
}
